import _ from 'lodash'

import {
  SET_LOGO
} from 'react-redux/actions/brand'


const initialState = {
  logo: "light-instruments"
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGO: {
      const { payload } = action
      return Object.assign({}, initialState, {logo: payload.logo})
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/brand.js